import {Pipe, PipeTransform} from '@angular/core';
import {IconDefinition} from "@fortawesome/fontawesome-common-types";
import {faBan} from "@fortawesome/free-solid-svg-icons";

export interface ITableIconPipe {
    params: any;
    index: number;
}

@Pipe({
    name: 'tableListIconPipe',
    pure: true
})
export class TableListIconPipe implements PipeTransform {
    transform(value: string, args: any): IconDefinition {
        const r = args[1]({params: args[0], index: args[2]});
        if (r) return r;
        return faBan;
    }
}
